<template>
  <div class="list shad">
    <div>
      <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center" class="mb-4">
        <div></div>
        <div style="color:gray"></div>
        <div style="color:white">
          <share-bar 
            :shareUrl="getShareUrl"
            :twitterShareMessage="getShareMessage"
            ></share-bar>
          <!-- <share-bar 
            v-if="published && publish" 
            :shareUrl="'https://listolinks.cabinetapps.com/u/' + $route.params.userId + '/' + publicId"
            :twitterShareMessage="title + ', a recipe by ' + $route.params.userId + ' on @ListOLinks @Blockstack'"
            ></share-bar> -->
        </div>
      </div>
      <h1>{{ title }}</h1>
      <div>{{ summary }}</div>
      <!-- <h3 class="mt-4 mb-4">Ingredients</h3> -->
      <!-- <ul>
        <li v-for="(item) in items" :key="item.id" class="m-2">{{ item.value }}</li>
      </ul> -->
      <b-card-group deck class="mt-4" style="">
          <link-card v-for="link in items" :key="link.id" :url="link.value"></link-card>
      </b-card-group>
      <!-- <h3 class="mt-4 mb-4">Instructions</h3> -->
      <!-- <div v-html="note">
      </div> -->
      <hr class="mt-5 mb-4" />
      <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center" class="mb-4">
        <div>
        </div>
        <div style="color:black">Shared by&nbsp;<strong>{{ $route.params.userId }}</strong></div>
        <div></div>
      </div>
      <div style="display:flex;flex-direction:row;justify-content:space-between;align-items:center" class="mb-4">
        <div>
        </div>
        <div style="color:black">Like this shared List O'Links? Created your own blockchain-powered <b-link :to="'/'" style="color:#003366;font-weight:bold">List O'Links</b-link> for free today!</div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields, mapMultiRowFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex'
// import NoteEditor from '@/components/NoteEditor'
// import EditableTitle from '@/components/EditableTitle'
// import SingleLineInput from '@/components/SingleLineInput'
// import { Person } from "blockstack";
// import { userSession } from "../userSession";
// import { EventBus } from '@/event-bus';
import store from '@/store/store'
import NProgress from 'nprogress'
import { setTimeout } from 'timers';
// import CodeEditor from '@/components/CodeEditor'
import ShareBar from '@/components/ShareBar'
import LinkCard from '@/components/LinkCard'

export default {
  data() {
    return {
      // columnDefs: null,
      // rowData: null
    }
  },
  computed: {
    ...mapFields([
      'listData',
      'listData.id',
      'listData.title',
      'listData.summary',
      'listData.type',
      'listData.showNote',
      'listData.note',
      'listData.createdAt',
      'listData.publish',
      'listData.publicId',
      'listData.published',
      'blockstack.user',
      'blockstack.userSession',
      'blockstack.user.username'
    ]),
    ...mapMultiRowFields(['listData.items']),
    ...mapGetters(['listsCount']),
    needsSave () {
      return this.$store.getters.needsSave
    },
    needsSave_currentList () {
      return this.$store.getters.needsSave_currentList
    },
    needsSave_lists () {
      return this.$store.getters.needsSave_lists
    },
    getShareUrl () {
      return "https://listolinks.cabinetapps.com/u/" + this.$route.params.userId + "/" + this.$route.params.id
    },
    getShareMessage () {
      return this.title + ", a List O'Links by " + this.$route.params.userId + " on @ListOLinks @Blockstack"
    }
  },
  mounted() {

    this.$store.commit('SET_ENABLETOOLBAR', false)

    // console.log('got note: ', this.note)

    // Fix Safari UI bug
    // if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {
    //   setTimeout(this.safariUIFix, 10);
    // }
  },
  methods: {
    shareMessage() {
      let s = this.title + ", a recipe on @TODO"
      return s
    }
  },
  beforeMount() {
  },
  beforeRouteEnter (routeTo, routeFrom, next) {
    // console.log('BEFORE ROUTE ENTER')
    let userId = routeTo.params.userId
    let resource = 'public/' + routeTo.params.id
    // console.log('loading public username:', userId)
    // console.log('loading public filename:', resource)
    store.dispatch('loadPublicResource', { userId, resource })
      .then(listData => {
        // console.log('loadlist - going on in router: ', listData)
        // console.log('got listData:', listData)
        if (listData != null) {
          // Double check if published
          // if (listData.publish == false || listData.published == false) {
          //   next({ name: '404', params: { resource: 'list' } })
          //   return
          // }
          next()
          return
        } else {
          // console.log('got error loadList - null')
          next({ name: '404', params: { resource: 'list' } })
        }
      })
      .catch(error => {
        console.log('got network error loadList', error)
        next({ name: 'network-issue' })
      })
  },
  beforeRouteUpdate (routeTo, routeFrom, next) {
    // console.log('BEFORE ROUTE UPDATE')
    let filename = 'public/' + routeTo.params.id
    // console.log('loading public filename:', filename)
    store.dispatch('loadPublicResource', filename)
      .then(listData => {
        // console.log('loadlist - going on in router: ', listData)
        console.log('got listData:', listData)
        if (listData != null) {
          // Double check if published
          if (listData.publish == false || listData.published == false) {
            next({ name: '404', params: { resource: 'list' } })
            return
          }
          next()
          return
        } else {
          // console.log('got error loadList - null')
          next({ name: '404', params: { resource: 'list' } })
        }
      })
      .catch(error => {
        console.log('got network error loadList', error)
        next({ name: 'network-issue' })
      })

  },
  components: {
    ShareBar,
    LinkCard
  },
  metaInfo: {
    title: "Shared List O'Links",
    titleTemplate: "%s | List O'Links",
    htmlAttrs: {
      lang: 'en',
      amp: false
    }
  }
}
</script>

<style scoped>
/* @import url('https://fonts.googleapis.com/css?family=Lexend+Deca&display=swap');
@import url('https://fonts.googleapis.com/css?family=Mansalva&display=swap');
@import url('https://fonts.googleapis.com/css?family=Indie+Flower&display=swap'); */
@import url('https://fonts.googleapis.com/css?family=Staatliches&display=swap');


h1 {
  font-family: 'Staatliches', sans-serif;
}

h3 {
  font-family: 'Staatliches', sans-serif;
}


.list {
  background-color: white;
  border-radius: 15px;
  padding: 20px;
  padding-top: 30px;
  padding-bottom: 30px;
  /* margin: 8px */
  margin-left: 5px;
  margin-right: 8px;
}

.shad {
  -webkit-box-shadow: 6px 6px 5px black;  /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */
  -moz-box-shadow:    6px 6px 5px black;  /* Firefox 3.5 - 3.6 */
  box-shadow:         6px 6px 5px black;  /* Opera 10.5, IE 9, Firefox 4+, Chrome 6+, iOS 5 */
}

li {
  font-size:22px;
}
li div {
  font-size:22px;
  /* font-weight:450; */
  /* font-family: 'Lexend Deca', sans-serif; */
}

.listitem {
  /* border: 1px dotted gray; */
}

.addbutton {
  cursor: pointer;
  padding: 5px;
  border-radius:10px;
  text-align:center;
  background-color: whitesmoke;
}

.addbutton:hover {
  background-color: lightgray;
}

.notebutton {
  cursor: pointer;
  padding: 5px;
  border-radius:10px;
  text-align:center;
}

.notebutton:hover {
  background-color: whitesmoke;
}

.notebox {
  
  margin-left:-10px;
  margin-right:-10px
}

.active {
  background: green;
  border: 1px dotted blue;
  display:inline;
}

.sli:hover + .deletebutton {
  display: block
}

.deletebutton {
    background-color:transparent;
    background-repeat:no-repeat;
    border: none;
    cursor:pointer;
    overflow: hidden;
    outline:none;
    width:40px;
    height:100%;
    margin-left: 5px;
    /* display:none; */
    /* border:1px solid gray; */
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

@media screen and (min-width: 500px) {

    .list {
      background-color: white;
      border-radius: 15px;
      padding: 50px;
      margin: 15px
    }

    .notebox {
      margin-left: 0px
    }
}

</style>